export function getTimeDiff(date1, timeSpan) {
  var startDate = new Date(date1);
  var seconds = (startDate.getTime() + timeSpan - startDate.getTime()) / 1000;
  return seconds;
}

export function compareDates(time) {
  var endTime = new Date(time);
  if (+endTime <= +new Date()) return true;
  return false;
}
